import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Base64 } from "js-base64";

// CANVAS
import Column from "canvas-core-react/lib/Column";
import TextBody from "canvas-core-react/lib/TextBody";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import Margin from "canvas-core-react/lib/Margin";
import TextHeadline from "canvas-core-react/lib/TextHeadline";
import Card from "canvas-core-react/lib/Card";
import Row from "canvas-core-react/lib/Row";
import TextCaption from "canvas-core-react/lib/TextCaption";

// COMPONENTS
import Layout from "../../components/Layout/Layout";
import Foot from "../../components/Layout/Foot";

// ROUTER
import { withRouter } from "../../utils/withRouter";

import { ReactComponent as Icon } from '../../components/icons/icon_successful.svg';
import { ReactComponent as Icon_responsive } from '../../components/icons/icon_successful_responsive.svg';

// STYLES
import "./style.scss";
import { useEffect } from "react";
import LoadingIndicator from "canvas-core-react/lib/LoadingIndicator";

import { CE_EVERTEC } from '../../constants/endpoints'
import resolveEnv from '../../Helpers/resolveEnv'
import { clickTagRut, stepsTagging_4 } from "../../utils/tagging";


const Successful = ({ }) => {
	const navigate = useNavigate();
	const [data, setData] = useState('');
	const { operationId } = useParams()
	let dato = window.parent.location.href
	let arr = dato.split('=')
	let value = decodeURIComponent(arr[1])
	arr = Base64.decode(value).split('&')
	let trx = arr[0].split('=')

	const ceURL = `${resolveEnv(CE_EVERTEC)}/${operationId}/${trx[1]}`;


	const getUrl = () => fetch(ceURL, {
		method: 'GET',
		headers: {
			"Content-Type": "application/json",
			"x-channel": "SPUB"
		},
	})
		.then(a => a.json())
		.then(a => {
			setData(a);
		})
		.catch(a => navigate('/error'));


	const evertec = async () => {
		try {
			const response = await getUrl();
		}
		catch (error) {
			navigate('/error')
		}
	};

	useEffect(() => {
		evertec();
	}, []);
	
	useEffect(() => {
		data != '' && (stepsTagging_4(data?.summary?.client_id, 'tipo', 'plazo', data?.summary?.payment_amount, 'tasa', 'banco'))
		data != '' && setTimeout(() => {
			clickTagRut("continuar", data?.summary?.client_id, "pago-exitoso");
			window.parent.location.href = data?.url_callback_super;
		}, "10000");
		
}, [data]);

return (
	<>
		<Layout idBlackBanner={0} showBanner={false}>
			{!data ?
				<Margin side="both" lg={192} md={192} style={{ display: 'flex !important', justifyContent: 'center !important' }}>
					<LoadingIndicator
						accessibleTitle="Loading"
						size="large"
						className='LoadingCenter'
					/>
				</Margin> :
				data?.status != 0 ? navigate('/error') :
					<>
						<Column lg={12} lgOffset={0}>
							<Margin side="top" lg={24} xs={12} />
							<Column xsHide smHide>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<Icon />
								</div>
							</Column>
							<Column lgHide mdHide>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<Icon_responsive />
								</div>
							</Column>
							<Margin side="bottom" lg={36} xs={12} />
							<TextHeadline id="Successful_title_2" style={{ marginBottom: '0' }}>¡Felicidades!</TextHeadline>
							<TextHeadline size="small" id="Successful_subtitle" style={{ marginBottom: '1.2rem' }}>
								El pago fue realizado con éxito
							</TextHeadline>
							<TextBody id="Successful_subtitle" type="1">
								Revisa el detalle del pago del monto de tu Depósito a Plazo.
							</TextBody>
							<Card type='floatLow' style={{ textAlign: 'center', paddingTop: '30px', paddingLeft: "12px", paddingRight: "12px" }}>
								<TextSubtitle type='1'>
									Resumen de transacción<br />
								</TextSubtitle>
								<TextBody id="Successful_tooltip_textNews" type="2">
									<Margin xs={6} sm={6} md={18} lg={18} side="top" />
									<Row >
										<Column xs={2} sm={4} md={6} lg={6} style={{ textAlign: 'end', padding: '0 5px' }}>
											<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
												Rut <br /><Margin lg={12} />
											</Margin>
										</Column>
										<Column xs={2} sm={4} md={6} lg={6} style={{ textAlign: 'start', padding: '0 5px' }}>
											<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
												<TextBody bold type="2" component="p" >
													{data?.summary?.client_id}<br /><Margin lg={12} />
												</TextBody>
											</Margin>
										</Column>
									</Row>
									<Row >
										<Column xs={2} sm={4} md={6} lg={6} style={{ textAlign: 'end', padding: '0 5px' }}>
											<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
												Cliente <br /><Margin lg={12} />
											</Margin>
										</Column>
										<Column xs={2} sm={4} md={6} lg={6} style={{ textAlign: 'start', padding: '0 5px' }}>
											<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
												<TextBody bold type="2" component="p" >
													{data?.summary?.client}<br /><Margin lg={12} />
												</TextBody>
											</Margin>
										</Column>
									</Row>
									<Row >
										<Column xs={2} sm={4} md={6} lg={6} style={{ textAlign: 'end', padding: '0 5px' }}>
											<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
												Monto de pago<br /><Margin lg={12} />
											</Margin>
										</Column>
										<Column xs={2} sm={4} md={6} lg={6} style={{ textAlign: 'start', padding: '0 5px' }}>
											<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
												<TextBody bold type="2" component="p" >
													{data?.summary?.payment_amount}<br /><Margin lg={12} />
												</TextBody>
											</Margin>
										</Column>
									</Row>
									<Row >
										<Column xs={2} sm={4} md={6} lg={6} style={{ textAlign: 'end', padding: '0 5px' }}>
											<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
												Nº Transacción<br /><Margin lg={12} />
											</Margin>
										</Column>
										<Column xs={2} sm={4} md={6} lg={6} style={{ textAlign: 'start', padding: '0 5px' }}>
											<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
												<TextBody bold type="2" component="p" >
													{data?.summary?.transaction_id}<br /><Margin lg={12} />
												</TextBody>
											</Margin>
										</Column>
									</Row>
									<Row >
										<Column xs={2} sm={4} md={6} lg={6} style={{ textAlign: 'end', padding: '0 5px' }}>
											<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
												Fecha<br /><Margin lg={12} />
											</Margin>
										</Column>
										<Column xs={2} sm={4} md={6} lg={6} style={{ textAlign: 'start', padding: '0 5px' }}>
											<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
												<TextBody bold type="2" component="p" >
													{data?.summary?.transaction_date}<br /><Margin lg={12} />
												</TextBody>
											</Margin>
										</Column>
									</Row>
									<Row >
										<Column xs={2} sm={4} md={6} lg={6} style={{ textAlign: 'end', padding: '0 5px' }}>
											<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
												Hora<br /><Margin lg={12} />
											</Margin>
										</Column>
										<Column xs={2} sm={4} md={6} lg={6} style={{ textAlign: 'start', padding: '0 5px' }}>
											<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
												<TextBody bold type="2" component="p" >
													{data?.summary?.transaction_hour}<br /><Margin lg={12} />
												</TextBody>
											</Margin>
										</Column>
									</Row>






								</TextBody>
								<Margin side="bottom" lg={24} md={24} />
								<TextCaption>
									El comprobante  se ha enviado al correo registrado a tu banco de pago.
								</TextCaption>
							</Card>
							<Margin side="both" lg={24}>
								<TextBody id="Successful_subtitle" type="1">
									Ahora revisa los comprobantes asociados a tus productos y activa tus claves Scotia.
								</TextBody>
							</Margin>
						</Column >
						<div style={{ textAlign: 'center' }}>
							<PrimaryButton
								style={{ width: '33%' }}
								labelPadding="36"
								onClick={() => {
									clickTagRut("continuar", data?.summary?.client_id, "pago-exitoso");
									window.parent.location.href = data?.url_callback_super;
								}}>
								Continuar
							</PrimaryButton>
						</div>
					</>
			}
		</Layout>
		<Foot />
	</>
);
}

export default withRouter(Successful);